(() => {
    const $dropdownMenus = document.querySelectorAll('.site-footer__dropdown-menu');

    const initDropdownMenus = () => {
        $dropdownMenus?.forEach($dropdownMenu => {
            new Details($dropdownMenu);
        });
    };

    initDropdownMenus();
})();
